const getContacts = (state) => {
  return state.contacts // No need for this
}
export default {
  getContacts
}



// WEBPACK FOOTER //
// ./src/store/modules/user/contacts/getters.js